module.exports = __webpack_public_path__ + "img/sphone_textlogo_white.bfe77928.svg";